import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from "react";
// old: import FileBase from 'react-file-base64';
import PhotoUploader from './PhotoUploader';

import { create } from "../../utilities/listings-service";
import loading from '../loading';
export default function NewListingForm  (){
    
  const [display, setDisplay] = useState({
    isLoaded: true,
    message: "Loading form"
  });

  const [error, setError] = useState('');
  const [listingData, setListingData] = useState({   

    title: '',
    rent: '',
    securityDeposit: '',
    utilities: '',
    description1: '',
    description2: '',
    pets: '',
    qualifications: '',
    available: false,
    // old: fixed 8-slot base64 fields, replaced by the photos array below
    // selectedFile1: '',
    // selectedFile2: '',
    // selectedFile3: '',
    // selectedFile4: '',
    // selectedFile5: '',
    // selectedFile6: '',
    // selectedFile7: '',
    // selectedFile8: '',
    photos: [],
  });


  const navigation = useNavigate();

  
  const formData = {...listingData}

  useEffect(()=>{
    setDisplay({
      isLoaded: true,
      message:""
    })
  },[])  

  useEffect(()=>{
    setDisplay({
      isLoaded: true,
      message:""
    })
  },[setError])

  
 const  handleSubmit = async (evt) => {
      let blnSuccess = false;
      evt.preventDefault()
      // console.log("formData: ", formData)
      try {
        setListingData(formData)
        setDisplay({
          ...display,
          isLoaded: false,
          message:"Creating new listing"
        })

        let responce = await create(formData)
        if (responce.staus==201) {
          navigation("/irunthis")
        }else{
          setDisplay({
            ...display,
            isLoaded: true,
            message:""
          })
        }
          
      } catch(error){
        setError(`Unexpected error! ${error.message}`);
        setDisplay(d => ({ ...d, isLoaded: true, message: "" }));
      }
      return blnSuccess
    }


    return display.isLoaded ?   (
     
      <div>


        <form  onSubmit={handleSubmit}>


          <div className = " create-form, form-container">
              <legend>Create New Listing</legend>
            
            <div className='form-title'>
              <label htmlFor = "title">Title:</label>
              <input type="text" name="title" id = "title" placeholder="Title" required onChange={(e) => setListingData({ ...listingData, title: e.target.value })}/>
            </div>
              
              
              <div className='prices'>
                <div>
                <label>Rent:</label>
                <input type="text" name="rent" placeholder="Monthly Rent Price" required onChange={(e) => setListingData({ ...listingData, rent: e.target.value })}/>
                </div>
                <div>
                <label>Security Deposit:</label>
                <input type="text" name="securityDeposit" placeholder="Security Deposit Price" required onChange={(e) => setListingData({ ...listingData, securityDeposit: e.target.value })}/>
                </div>          
              </div>

              <label>Utilities:</label>
              <textarea className='small-textarea' name="utilities" placeholder="Enter utilities policy" onChange={(e) => setListingData({ ...listingData, utilities: e.target.value })}/> 
                

                
                <label>Description Paragraph 1:</label>
                <textarea className='description'  name="description1" placeholder="Description" required onChange={(e) => setListingData({ ...listingData, description1: e.target.value })}/>
                
                <label>Description Paragraph 2:</label>
                <textarea className='description' name="description2" placeholder="Description" onChange={(e) => setListingData({ ...listingData, description2: e.target.value })}/> 
                

                <label>Pets:</label>
                <textarea className='small-textarea' name="pets" placeholder="Enter pet policy" onChange={(e) => setListingData({ ...listingData, pets: e.target.value })}/> 
                  
                  
                  
        


                <label>Qualifications: </label>
                <textarea  name="qualifications" placeholder="Enter Minimum Qualifications for Residents devided by ." required onChange={(e) => setListingData({ ...listingData, qualifications: e.target.value })}/>


                <div className = "checkr">
                  <label className='available'>Available: &nbsp;</label>
                  <label className="switch">
                    <input type="checkbox" name="available" onChange={(e) => setListingData({ ...listingData, available: e.target.value })} />
                    <span className="slider"></span>
                  </label>
                </div>
         



              

                
                {/* old: 8 separate FileBase inputs, replaced by PhotoUploader (drag-and-drop, multi-file, uploads to Cloudinary)
                <div className='photos'>
                  <div className = "file-input-wrapper">
                    <label className="input-group-text" htmlFor="selectedFile1">Select Main Photo</label>
                    <FileBase type="file" className="fileBtn" id="selectedFile1" name = "selectedFile1" multiple={false}  onDone={({ base64 }) => setListingData({ ...listingData, selectedFile1: base64 })} />
                  </div>
                  ... (selectedFile2 through selectedFile8 were identical, one FileBase per slot)
                </div>
                */}
                <div className='photos'>
                  <PhotoUploader photos={listingData.photos} onChange={(newPhotos) => setListingData({ ...listingData, photos: newPhotos })} />
                </div>
                  <div>
                    PS. There is ALREADY a FLOOR PLAN in Photos, DO NOT Add it here
                  </div>

                <p className="error-message">&nbsp;{error}</p>
              <button type="submit">Create Listing</button>
          
            </div>
      

          
          
        </form>
      </div>
    ): loading(display.message)
}